'use es6';

import * as RespondentTypes from '../respondentTypes';
export const DefaultCustomThankYou = 'successfully-submitted-question';
export default {
  [RespondentTypes.DETRACTOR]: 'customer-support',
  [RespondentTypes.PASSIVE]: 'nps-question-thank-you',
  [RespondentTypes.PROMOTER]: 'successfully-submitted-question'
};